import {useEffect} from "react";
import usePrevious from "../../utils/UsePrevious";
import {isPageInfoEqual} from "../../utils/PageInfoUtils";

/**
 * Hook um die Initialisierung von Arbeitslisten mit Personalisierung und Pagination korrekt zu initialisieren.
 * @param sharedFilter der sharedFilter
 * @param storedFilter der storedFilter
 * @param executeSearch Funktion zum Ausführen der Suche
 */
export default function usePersonalisationAndPagination(sharedFilter, storedFilter, executeSearch) {
    const prevPageInfo = usePrevious(storedFilter.pageInfo);
    useEffect(() => {
        if (!isPageInfoEqual(prevPageInfo, storedFilter.pageInfo)) {
            executeSearch(storedFilter, sharedFilter);
        }
    }, [storedFilter.pageInfo, executeSearch, storedFilter, sharedFilter, prevPageInfo]);
}
